<template>
<div class="pagewide panel mtpage">

	<topheader>
		<template v-slot:info>
			<span>{{$t('app.panel')}}</span>
		</template>
		<template v-slot:right>
			
		</template>

	</topheader>

	<maincontent>
		<template v-slot:content>
            <panel />
		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>
	

</style>

<script>

import panel from "@/components/modules/panel/index.vue"


export default {
	name: 'panel_page',
	components: {
		panel
	},

	data : function(){
		return { 
			searchEnabled : false
		}
	},

	computed: {

	},

	methods: {
		
	},

	mounted() {

	}
}
</script>
